module.exports = (opts) => {
  let delta = 0
  let offset = 0
  if (opts) {
    if (!isNaN(opts.min) && !isNaN(opts.max)) {
      delta = opts.max - opts.min + 1
      offset = opts.min
    }
  }
  return { delta: delta, offset: offset }
}



// WEBPACK FOOTER //
// ./src/private/scanners/integer.js